import { ConfigService } from '@nextgen-web-framework/core';
import { parsePhoneNumber } from 'libphonenumber-js';
import { PhoneDisplayFormat } from '../Constants';

const useTransformPhoneNumber = () => {
  const { PHONE_DISPLAY_FORMAT } = ConfigService.getConfigs();
  const transformPhoneNumber = (phoneNumber: string) => {
    try {
      const parsedPhoneNumber = parsePhoneNumber(phoneNumber);
      if (PHONE_DISPLAY_FORMAT === PhoneDisplayFormat.NATIONAL) {
        const nationalPhoneNumber = parsedPhoneNumber?.formatNational();
        return nationalPhoneNumber != null ? nationalPhoneNumber.replace(/[\s+]/g, '') : '';
      } else if (PHONE_DISPLAY_FORMAT === PhoneDisplayFormat.INTERNATIONAL) {
        return parsedPhoneNumber?.formatInternational();
      } else {
        return phoneNumber;
      }
    } catch (error) {
      // parsePhoneNumber will throw errors if phone is not valid
      return phoneNumber;
    }
  };

  return { transformPhoneNumber };
};

export default useTransformPhoneNumber;
